/*
 * vld-home.js - behaviour for the VickersLDN homepage sections (sections/vld-home-*.liquid, vld-shop-by, vld-promise...).
 *
 * Only the hero needs script: its live demo mounts the customiser (assets/vld-editor.js + vld-design.js) on an
 * offscreen root for the configured design, mirrors the "Type a name" input into the editor's first text field,
 * builds colour swatches from editor.colours(), and copies the editor's engraved canvas into the hero canvas on
 * user change. Until interaction (or for ever, if the hub / scripts are missing) the hero shows its <img>.
 *
 * Every section is optional: the script does nothing when a section or an element is absent. Loaded with defer
 * by each section; the guard below keeps it to one run per page. Re-runs for the theme editor's section events.
 */
(function () {
  'use strict';
  if (window.__vldHome) return;
  window.__vldHome = true;

  var SWATCH = {   // recipe colour -> swatch colour; anything unknown gets a neutral disc
    tan: '#b8865a', marigold: '#d9a23b', charcoal: '#3b3b3b', espresso: '#4a2f23', hazelnut: '#8b6b4f',
    black: '#1a1a1a', brown: '#5b3d2a', navy: '#232c45', grey: '#8c8c8c', gray: '#8c8c8c', red: '#8a2a2a',
    pink: '#d9a0a8', blue: '#5b7a9a', green: '#4b6b4a', cream: '#efe7d6', white: '#f5f5f3'
  };
  var norm = function (s) { return String(s || '').toLowerCase().replace(/hazlenut/, 'hazelnut').trim(); };

  function parseConfig(sec) {
    var el = sec.querySelector('[data-vld-home-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initHero(sec) {
    if (!sec || sec.__vldInit) return;
    sec.__vldInit = true;
    var cfg = parseConfig(sec) || {};
    var input = sec.querySelector('[data-vld-demo-input]');
    var count = sec.querySelector('[data-vld-demo-count]');
    var canvas = sec.querySelector('[data-vld-demo-canvas]');
    var swatchBox = sec.querySelector('[data-vld-demo-swatches]');
    var colourName = sec.querySelector('[data-vld-demo-colour]');
    var maxLen = input ? (+input.getAttribute('maxlength') || 14) : 14;
    var editor = null, live = false, root = null, lastValue = null;
    var interacted = false, pendingName = null;

    // Keep the Liquid-selected product stable for this page load. Do not replace
    // the first-paint photograph using client context or an intermediate editor draw.

    function updateCount() {
      if (count && input) count.textContent = input.value.length + '/' + maxLen;
    }
    if (input) { input.addEventListener('input', updateCount); updateCount(); }

    // the editor's own textarea for the first text layer: writing there runs the editor's normal input path
    function firstField() {
      return root ? root.querySelector('.vld-ed__fields textarea') : null;
    }
    function push(value) {
      pendingName = value;
      var ta = firstField();
      if (!ta) return;
      if (value === lastValue) return;
      lastValue = value;
      ta.value = value;
      ta.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function copyCanvas() {
      var src = root && root.querySelector('.vld-ed__product');
      if (!src || !src.width || !canvas) return false;
      if (canvas.width !== src.width || canvas.height !== src.height) { canvas.width = src.width; canvas.height = src.height; }
      canvas.getContext('2d').drawImage(src, 0, 0);
      return true;
    }

    function showPreview(state) {
      if (!interacted || !root) return;
      if (pendingName !== null) {
        var texts = state && state.texts || {};
        var first = Object.keys(texts)[0];
        if (!first || texts[first] !== pendingName) return;
      }
      if (!copyCanvas()) return;
      live = true;
      sec.classList.add('is-live');
      sec.classList.remove('is-busy');
    }

    function selectSwatch(key) {
      if (!swatchBox) return;
      var buttons = swatchBox.querySelectorAll('.vld-demo__swatch');
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i].getAttribute('data-colour') === key;
        buttons[i].classList.toggle('is-selected', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      if (colourName) colourName.textContent = key;
    }

    function buildSwatches(keys, current) {
      if (!swatchBox || !keys || !keys.length) return;
      swatchBox.innerHTML = '';
      keys.slice(0, 5).forEach(function (key) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vld-demo__swatch';
        b.setAttribute('data-colour', key);
        b.setAttribute('aria-label', (cfg.swatchLabel || 'Colour') + ': ' + key);
        b.title = key;
        var img = cfg.swatchImages && cfg.swatchImages[norm(key)];
        if (img) b.style.backgroundImage = 'url("' + img + '")';
        else b.style.backgroundColor = SWATCH[norm(key)] || '#cfc8bd';
        b.addEventListener('click', function () {
          interacted = true;
          selectSwatch(key);
          if (editor) editor.setProduct({ colour: key });
        });
        swatchBox.appendChild(b);
      });
      swatchBox.hidden = false;
      selectSwatch(current || keys[0]);
    }

    function fail() {
      sec.classList.remove('is-live');
      if (root && root.parentNode) root.parentNode.removeChild(root);
      root = null; editor = null;
      // the fallback image is already showing: nothing else to do
    }

    function start() {
      if (!canvas || !cfg.designId || !cfg.hub || !window.VLDEditor || !window.VLD) return;
      if (typeof OffscreenCanvas === 'undefined') return;   // the editor engraves in OffscreenCanvas
      root = document.createElement('div');
      root.className = 'vld-home-edroot';
      root.setAttribute('aria-hidden', 'true');
      // offscreen but laid out at a real width: the editor's SVG stage needs geometry
      root.style.cssText = 'position:absolute;left:-300vw;top:0;width:600px;height:auto;overflow:hidden;pointer-events:none;visibility:hidden;';
      sec.appendChild(root);
      var opts = {
        hub: cfg.hub, designId: +cfg.designId, base: String(cfg.base || '34'),
        onColour: function (c) { selectSwatch(c); },
        onChange: showPreview
      };
      if (cfg.colour) opts.colour = cfg.colour;
      var timer = setTimeout(function () { if (!live) fail(); }, +cfg.timeoutMs || 25000);
      window.VLDEditor.mount(root, opts).then(function (api) {
        if (!root) return; // a timed-out mount must not resurrect a removed editor
        editor = api;
        clearTimeout(timer);
        try { buildSwatches(api.colours(), api.state().product.colour); } catch (e) { /* no swatches, the demo still works */ }
        if (input) {
          if (interacted) push(input.value); // a name typed while the editor was loading
        }
        new MutationObserver(function () { sec.classList.toggle('is-busy', root && root.classList.contains('is-busy')); })
          .observe(root, { attributes: true, attributeFilter: ['class'] });
      }).catch(function () { clearTimeout(timer); fail(); });
    }

    // Register immediately: typing while fonts/plates load must not be lost.
    if (input) input.addEventListener('input', function () {
      interacted = true;
      sec.classList.add('is-busy');
      push(input.value);
    });

    // swatch discs are crops of the real leather photos (hub /pub/swatches/<base>.json), not a hex guess
    function loadSwatches() {
      if (!cfg.hub || !window.fetch) return Promise.resolve();
      return fetch(cfg.hub.replace(/\/$/, '') + '/pub/swatches/' + encodeURIComponent(cfg.base || '34') + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (map) {
          if (!map) return;
          cfg.swatchImages = cfg.swatchImages || {};
          Object.keys(map).forEach(function (k) { if (map[k] && map[k].image) cfg.swatchImages[norm(k)] = map[k].image; });
        }).catch(function () { /* fall back to the colour map */ });
    }

    // the photo is the first paint; the customiser (fonts, plate, design) starts once the page has loaded
    function go() { loadSwatches().then(function () { setTimeout(start, 0); }); }
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
  }

  function initAll(scope) {
    var heroes = (scope || document).querySelectorAll('[data-vld-home-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // theme editor: a section added or re-rendered
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
